/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ x: NonNullable<unknown> }} Manual_Balancing_History_Max_Range_ErrorInputs */



/**
* | output |
* | --- |
* | "The period cannot exceed {x} days" |
*
* @param {Manual_Balancing_History_Max_Range_ErrorInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const manual_balancing_history_max_range_error = /** @type {((inputs: Manual_Balancing_History_Max_Range_ErrorInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Balancing_History_Max_Range_ErrorInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`The period cannot exceed ${i?.x} days`)
	return /** @type {LocalizedString} */ (`La période ne peut pas dépasser ${i?.x} jours`)
});